var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,63.9C14.5,63.9,0.1,49.5,0.1,32S14.5,0.1,32,0.1S63.9,14.4,63.9,32S49.5,63.9,32,63.9z M32,5 C17.1,5,5,17.1,5,32s12.1,27,27,27s27-12.1,27-27S46.9,5,32,5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.2,39.2l-1.7,1L42,34.6h-7.7V19.1h-3.8v7.4l0,0v3.9l0,0v1.1l0,0v3l0,0v4h9.6l2.3,3l3,3.8l4.6-2.6 L48.2,39.2z M38.6,39.8c0.2,2.5-0.5,4.9-2,6.9c-1.7,2.2-4.1,3.7-6.9,4.2c-5.7,0.9-11-3-12-8.8c-0.9-5.7,3-11,8.8-11.9 c0.9-0.1,1.7-0.2,2.5-0.1v-3.7c-3.3-0.2-6.5,0.8-9.2,2.7c-3.1,2.2-5.1,5.5-5.7,9.3c-0.6,3.8,0.3,7.5,2.6,10.6 c2.2,3.1,5.5,5.1,9.3,5.7c0.7,0.1,1.5,0.2,2.2,0.2c3,0,5.9-0.9,8.4-2.7c2.9-2.1,4.8-5.1,5.5-8.6l-2.6-3.8H38.6z M29.8,46.4 c-1.6,0.4-3.3,0.2-4.8-0.7c-1.4-0.9-2.4-2.3-2.8-4c-0.4-1.6-0.2-3.3,0.7-4.8c0.9-1.4,2.3-2.4,3.9-2.8c0.8-0.2,1.5-0.2,2.2-0.1 v-2.9c-4.4-0.4-8.4,2.3-9.6,6.7c-0.3,1-0.3,1.8-0.3,2.6c0,5.1,4.1,9.2,9.2,9.2s9.2-4.1,9.2-9.2c0-0.2,0-0.4,0-0.6h-2.9 c0.1,1.3-0.2,2.7-0.9,3.8C32.9,45,31.5,46,29.8,46.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32.5,
    cy: 13.1,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.2,38.3L40.2,38.3L40.2,38.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType26);
export default __webpack_public_path__ + "static/media/aioa-icon-type-26.ceb94c557fb12feafe688a578fad14dd.svg";
export { ForwardRef as ReactComponent };